<template>
  <div class="hello">
    <md-app>

      <md-app-drawer md-permanent="clipped">
        <md-toolbar class="md-transparent" md-elevation="0">
          <div class="logo">
            <img src="../assets/MM-lock-up@3x.png">
            <h1 class="title">Mamamia Management System</h1>
          </div>
        </md-toolbar>

        <md-list>

          <md-divider></md-divider>

          <md-subheader v-if="permissionLookup('articlesSection', permission)">Articles</md-subheader>

          <md-list-item v-if="permissionLookup('create-article', permission)" @click="currentTab = 'create-article'" :class="currentTab === 'create-article' ? 'active-item' : 'z'">
            <md-icon>note_add</md-icon>
            <span class="md-list-item-text">Create Article</span>
            <md-tooltip md-direction="right">Create Article</md-tooltip>
          </md-list-item>

          <md-list-item v-if="permissionLookup('articleList', permission)" @click="currentTab = 'articleList'" :class="currentTab === 'articleList' ? 'active-item' : ''">
            <md-icon>list</md-icon>
            <span class="md-list-item-text">List Articles</span>
            <md-tooltip md-direction="right">List Articles</md-tooltip>
          </md-list-item>


          <md-divider v-if="permissionLookup('articlesSection', permission)"></md-divider>

          <md-subheader v-if="permissionLookup('verticalsSection', permission)">Verticals</md-subheader>

          <md-list-item v-if="permissionLookup('widgets', permission)" @click="currentTab = 'widgets'" :class="currentTab === 'widgets' ? 'active-item' : ''">
            <md-icon>view_agenda</md-icon>
            <span class="md-list-item-text">Widgets</span>
            <md-tooltip md-direction="right">Widgets</md-tooltip>
          </md-list-item>

          <md-list-item v-if="permissionLookup('seo', permission)" @click="currentTab = 'seo'" :class="currentTab === 'seo' ? 'active-item' : ''">
            <md-icon>pageview</md-icon>
            <span class="md-list-item-text">SEO</span>
            <md-tooltip md-direction="right">SEO</md-tooltip>
          </md-list-item>

          <md-list-item v-if="permissionLookup('categories', permission)" @click="currentTab = 'categories'" :class="currentTab === 'categories' ? 'active-item' : ''">
            <md-icon>category</md-icon>
            <span class="md-list-item-text">Manage</span>
            <md-tooltip md-direction="right">Manage Categories</md-tooltip>
          </md-list-item>

          <md-divider v-if="permissionLookup('verticalsSection', permission)"></md-divider>

          <md-subheader v-if="permissionLookup('videosSection', permission)">Videos</md-subheader>



          <md-list-item v-if="permissionLookup('videos', permission)" @click="currentTab = 'videos'" :class="currentTab === 'videos' ? 'active-item' : ''">
            <md-icon>video_library</md-icon>
            <span  class="md-list-item-text">Playlists</span>
            <md-tooltip md-direction="right">Video Playlists</md-tooltip>
          </md-list-item>

          <md-divider v-if="permissionLookup('videosSection', permission)"></md-divider>

          <md-subheader v-if="permissionLookup('podcastsSection', permission)">Podcasts</md-subheader>

          <md-list-item v-if="permissionLookup('podcasts', permission)" @click="currentTab = 'podcasts'" :class="currentTab === 'podcasts' ? 'active-item' : ''">
            <md-icon>playlist_add</md-icon>
            <span class="md-list-item-text">Add Podcast</span>
            <md-tooltip md-direction="right">Add Podcast</md-tooltip>
          </md-list-item>

          <md-list-item v-if="permissionLookup('podcasts', permission)" @click="currentTab = 'podcasts'" :class="currentTab === 'podcasts' ? 'active-item' : ''">
            <md-icon>playlist_play</md-icon>
            <span class="md-list-item-text">List Podcasts</span>
            <md-tooltip md-direction="right">List Podcasts</md-tooltip>
          </md-list-item>

          <md-divider v-if="permissionLookup('podcastsSection', permission)"></md-divider>

          <md-subheader v-if="permissionLookup('competitionsSection', permission)">Branded</md-subheader>

          <md-list-item v-if="permissionLookup('branded', permission)" @click="currentTab = 'branded'" :class="currentTab === 'branded' ? 'active-item' : ''">
            <md-icon>add</md-icon>
            <span class="md-list-item-text">AJAX Tracker</span>
            <md-tooltip md-direction="right">AJAX Tracker</md-tooltip>
          </md-list-item>

          <md-list-item v-if="permissionLookup('competitions', permission)" @click="currentTab = 'competitions'" :class="currentTab === 'competitions' ? 'active-item' : ''">
            <md-icon>add</md-icon>
            <span class="md-list-item-text">Create Competition</span>
            <md-tooltip md-direction="right">Create Competition</md-tooltip>
          </md-list-item>

          <md-list-item v-if="permissionLookup('competitions', permission)" @click="currentTab = 'competitions'" :class="currentTab === 'competitions' ? 'active-item' : ''">
            <md-icon>view_list</md-icon>
            <span class="md-list-item-text">List Competitions</span>
            <md-tooltip md-direction="right">List Competitions</md-tooltip>
          </md-list-item>

          <md-divider v-if="permissionLookup('competitionsSection', permission)"></md-divider>

          <md-subheader v-if="permissionLookup('adminSection', permission)">Admin</md-subheader>

          <md-list-item v-if="permissionLookup('tags', permission)" @click="currentTab = 'tags'" :class="currentTab === 'tags' ? 'active-item' : ''">
            <md-icon>label</md-icon>
            <span class="md-list-item-text">Tags</span>
            <md-tooltip md-direction="right">Tag Management</md-tooltip>
          </md-list-item>

          <md-list-item v-if="permissionLookup('users', permission)" @click="currentTab = 'users'" :class="currentTab === 'users' ? 'active-item' : ''" >
            <md-icon>supervisor_account</md-icon>
            <span class="md-list-item-text">Users</span>
            <md-tooltip md-direction="right">User Management</md-tooltip>
          </md-list-item>

          <md-list-item v-if="permissionLookup('authors', permission)" @click="currentTab = 'authors'" :class="currentTab === 'authors' ? 'active-item' : ''" >
            <md-icon>person_outline</md-icon>
            <span class="md-list-item-text">Authors</span>
            <md-tooltip md-direction="right">Author Management</md-tooltip>
          </md-list-item>

          <md-divider v-if="permissionLookup('adminSection', permission)"></md-divider>
        </md-list>
      </md-app-drawer>

      <md-app-content>
        <component :is="currentTab"></component>
      </md-app-content>
    </md-app>
  </div>
</template>

<script>
import Vue from "vue";
import firebase from "firebase";
require("firebase/firestore");
var firestore;

import request from "axios";
import videos from "./pages/videos";
import podcasts from "./pages/podcasts";
import seo from "./pages/seo";
import categories from "./pages/categories";

import gridX from "./widgets/gridX";

import branded from "./pages/branded";
import users from "./pages/users";
import authors from "./pages/authors";
import tags from "./pages/tags";
import images from "./pages/images";
import competitions from "./pages/competitions";
import articleList from "./pages/articleList";
import createArticle from "./pages/createArticle";
import redirects from "./pages/redirects";
import widgets from "./pages/widgets";
import config from "../config.json";

import moment from "moment";

export default {
  name: "hello",
  components: {
    users,
    authors,
    videos,
    podcasts,
    branded,
    redirects,
    seo,
    createArticle,
    widgets,
    categories,
    gridX,
    images,
    competitions,
    articleList,
    tags
  },
  data() {
    firestore = firebase.firestore();
    return {
      menuVisible: false,
      pages: [],
      editData: {},
      showModalCreate: {
        add: false,
        edit: false
      },
      permission: [],
      permissionRestrictions: {

        // Admin Permissions
        "users": ["admin"],
        "authors": ["admin"],

        // Podcast Permissions
        "podcastsSection": ["admin", "podcast"],
        "podcasts": ["admin", "podcast"],

        // Writer Permissions
        "articlesSection": ["admin", "editor", "writer"],
        "create-article": ["admin", "editor", "writer"],
        "articleList": ["admin", "editor", "writer"],
        "branded": ["admin","branded"],
        "competitionsSection": ["admin", "editor", "writer"],
        "competitions": ["admin", "editor", "writer","branded"],


        // Video Team Permissions
        "videosSection": ["admin", "video"],
        "videos": ["admin", "video"],

        // Editor Permissions
        "verticalsSection": ["admin", "editor", "writer"],
        "adminSection": ["admin", "editor", "writer"],
        "tags": ["admin", "editor"],
        "widgets": ["admin", "editor"],
        "redirects": ["admin", "editor"],
        "seo": ["admin", "editor"],
        "categories": ["admin", "editor"]

      },
      previewImage: "",
      showModalEdit: false,
      currentTab: "widgets",
      updateWidgetMessage: null,
      permission: [],
      showCreateNewPage: false,
      newWidgetButton: "",
      showTitle: true,
      infiniteScroll: false
    };
  },
  methods: {
    processPreviewImage: function(event) {
      if (event.target.files && event.target.files[0]) {
        var reader = new FileReader();
        reader.onload = e => {
          console.log(e);
          Vue.set(this, "previewImage", e.target.result);
        };
        reader.readAsDataURL(event.target.files[0]);
      } else {
        Vue.set(this, "previewImage", "");
      }
    },

    permissionLookup: function(type) {
      var permissionApproved = false;
      console.log(type);
      this.permissionRestrictions[type].forEach((restrictions) => {
        this.permission.forEach((userPermission) => {
          if(restrictions.indexOf(userPermission) > -1) permissionApproved = true;
        });
      });
      return permissionApproved;

    },

    logout: function() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace("login");
        });
    },

    refreshSlug: function() {
      var retVal = prompt(
        "Enter the slug of the ARTICLE page to refresh. Do not use this for refreshing widget pages, it wont work. ",
        "enter slug here"
      );
      request
        .get(
          config.apiFrontend + "/refreshPage?slug=" +
            retVal +
            "&type=page&cachebuster=" +
            Date.now()
        )
        .then(response => {
          alert(response.data);
        });
    },



  },
  mounted() {
    firestore
      .collection("users")
      .doc(firebase.auth().currentUser.uid)
      .get()
      .then((snap) => {
        var data = snap.data();
        console.log(data, data.permission);
        this.permission = data.permission
        window.globalUser = data;
      });
  }
};
</script>

<style scoped>
.md-list-item {
      margin: 0;
}
  .md-app {
    min-height: 350px;
    overflow:unset !important;
  }

  .md-drawer {
    width: 212px;
    max-width: calc(100vw - 125px);
    min-height: 100vh;
    min-width:50px;
        z-index: 0 !important;
  }
  @media (max-width: 1500px) {
    .md-subheader {
      display:none;
    }
  }
</style>
<style>
/* .fr-wrapper > div:not(.fr-element) {
    height: 1px !important;
    overflow: hidden !important;
} */
:root {
  --inputColor: aliceblue;
}
.md-ripple {
  font-size: 0 !important;
}
.md-ripple * {
  font-size: initial;
}
.tag-input-container .multiselect__tags {
    border: none;
    min-height:28px;
}
.tag-input-container .multiselect {
    min-height:auto;
    height: auto;
}
html {
  box-sizing: border-box;
}
*,
*:before,
*:after {
  box-sizing: inherit;
}
.draggable-items {
  width: 100%;
  padding: 5px;
  border: 1px solid white;
  margin-bottom: 5px;
  overflow: auto;
  cursor: pointer;
}
.md-app-container {
  overflow: initial !important;
}
.md-list-item.active-item .md-list-item-button .md-list-item-content {
  background-color: rgba(100,100,100,0.4);
}

/* Bodgy McBodge */
.md-list-item-content {
  font-size: 0;
}
.md-list-item-content span {
  font-size: 14px;
}

/* .redirect > span {
  flex: 1 0 33%;
} */

.draggable-items button {
  margin-right: 10px;
}

.draggable-icon {
  cursor: grab;
}
.sortable-chosen {
  background-color: #7a839a;
}
.sortable-ghost {
  background-color: #37415d;
}


.active {
  background-color: #1a3246;
  font-weight: bold;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin: 0 10px;
  cursor: pointer;
}

a {
  color: #42b983;
}

h1,
h2,
h3 {
  /* font-weight: normal; */
  border-bottom: 1px solid white;
  font-size: 1.17em;
}
h4 {
  margin-bottom: 0;
}

button {
  background: rgba(54, 74, 94, 1);
  border: 0;
  color: aliceblue;
  font-weight: bold;
  padding: 0.8em 1.3em;
  font-size: 0.85em;
  cursor: pointer;
}


.sr {
  position: absolute;
  height: 1px;
  width: 1px;
  clip: rect(1px 1px 1px 1px);
  clip: rect(1px, 1px, 1px, 1px);
  clip-path: polygon(0px 0px, 0px 0px, 0px 0px);
  -webkit-clip-path: polygon(0px 0px, 0px 0px, 0px 0px);
  overflow: hidden !important;
}

.flex {
  display: flex;
}

.flex-1 {
  flex: 1;
}

.flex-2 {
  flex: 2;
}

.flex-3 {
  flex: 3;
}

.flex-space-between {
  justify-content: space-between;
}

.center-flex {
  justify-content: center;
  align-items: center;
}

.center-flex-x {
  justify-content: center;
}

.center-flex-y {
  align-items: center;
}

/* .grid {
  --gridtemp: 1fr 1fr 1fr;
  display: grid;
  grid-gap: 2em;
  grid-template-columns: var(--gridtemp);
} */

/* .btn-round {
  border-radius: 50%;
  width: 50px;
  height: 50px;
} */
.logo {
  margin: 10px auto;
}
.logo > img {
  width: 160px;
}

.title {
    color: #fff;
    font-size: 0.75em;
    line-height: 1;
    margin: 0;
    text-align: center;
    border-bottom: 0px;
}

nav > ul {
  display: flex;
  justify-content: space-around;
  height: 100%;
  align-items: center;
  margin: 0;
}

.nav-item {
  position: relative;
  text-transform: uppercase;
  white-space: nowrap;
}

.nav-item:before {
  /* font-weight: bold;
  border-bottom: 2px solid #ee5199; */
  content: "";
  position: absolute;
  width: 100%;
  height: 2px;
  bottom: 0;
  left: 0;
  background-color: #ee5199;
  visibility: hidden;
  -webkit-transform: scaleX(0);
  transform: scaleX(0);
  -webkit-transition: all 0.3s ease-in-out 0s;
  transition: all 0.3s ease-in-out 0s;
}

.nav-item:hover:before,
.nav-item.active-item:before {
  visibility: visible;
  -webkit-transform: scaleX(1);
  transform: scaleX(1);
  letter-spacing: 0;
}
.input-box {
  border: 1px solid white;
  height: 30px;
  background: #24343c;
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 0.75em;
  color: white;
}

.input-box select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  color: var(--inputColor);
  z-index: 10;
}
.input-box select::-ms-expand {
  display: none;
}
/* .input-box select {
  color: var(--inputColor);
  z-index: 10;
} */

.input-box select,
.input-box input {
  background: transparent;
  border: 0;
  font-size: 1em;
  color: var(--inputColor);
  width: 100%;
  padding: 0.3em 0.5em;
  box-sizing: border-box;
  position: relative;
}

.input-box input[type="checkbox"] {
  width: auto !important;
}

select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--inputColor);
}

option {
  color: black;
}

option::first-of-type {
  color: red;
}
option:disabled {
  color: #cfcfcf;
}

.input-box input::placeholder {
  color: var(--inputColor);
}

.down-caret {
  position: relative;
}
.down-caret:after {
  content: "";
  position: absolute;
  height: 0.5em;
  width: 0.5em;
  right: 0.5em;
  top: calc(50% - 0.45em);
  border-style: solid;
  border-color: white;
  border-width: 0 0.15em 0.15em 0;
  transform: rotate(45deg);
}

.add-new-page {
  background: transparent;
  border: 0;
  font-size: 1em;
  color: #fff;
  margin-top: -3px;
  margin-left: 6px;
}

.widget-buttons {
  margin-bottom: 1em;
}

.widget-type {
  font-size: 1em;
  font-weight: bold;
  font-style: italic;
  margin: 0 0 0.25em;
}


/* HTML Editor Styles */
@keyframes fade-in-n-out {
    0% { opacity: 0; }
    50% { opacity: 1; }
    100% { opacity: 0; }
}

.editor-container {
  width: 100%;
  height: 500px;
  position: relative;
  margin-bottom: 1em;
}

.editor {
  width: 100%;
  height: 500px;
}

.editor-overlay {
  color: #ffffff;
  font-size: 2em;
  position: absolute;
  background: rgba(190, 217, 248, 0.384);
  height: 500px;
  width: 100%;
  justify-content: center;
  align-items: center;
  display: none;
  opacity: 0;
  z-index: 1;
}

.editor-overlay.is-visible {
  display: flex;
  animation: fade-in-n-out 3s;
}

.upload-container {
  background: #24343c;
  display: flex;
  margin-bottom: 20px;
}
.upload-container img {
  height: 100px;
  width: 100px;
  margin-left: auto;
}
.upload-container .upload-btn {
  display: flex;
  flex-direction: row-reverse;
  height: 30px;
  margin: auto 10px;
}
.upload-container .upload-btn {
  display: flex;
  align-items: center;
}

.spinner {
  padding: 1em;
}
</style>



// WEBPACK FOOTER //
// Hello.vue?2eada267